import getInfoBarMessageIdsInCompose from './getInfoBarMessageIdsInCompose';
import addInfoBarMessage from '../actions/addInfoBarMessage';
import removeInfoBarMessage from '../actions/removeInfoBarMessage';
import ComposeViewState from '../store/schema/ComposeViewState';
import InfoBarMessageViewStateCreator from 'owa-info-bar/lib/schema/InfoBarMessageViewStateCreator';

const infoBarAddHandler = (viewState: ComposeViewState) => (
    messageId: string,
    infoBarMessageViewStateCreator: InfoBarMessageViewStateCreator
) => {
    addInfoBarMessage(viewState, messageId, infoBarMessageViewStateCreator);
};

const infoBarRemoveHandler = (viewState: ComposeViewState) => (messageIds: string[]) => {
    removeInfoBarMessage(viewState, messageIds);
};

const infoBarGetIdsHandler = (viewState: ComposeViewState) => () => {
    return getInfoBarMessageIdsInCompose(viewState);
};

export { infoBarAddHandler, infoBarRemoveHandler, infoBarGetIdsHandler };
